import {User} from 'constants/UserConstants';
import {Team} from 'orgs/OrganizationConstants';

import {RequestAssignee, RequestAssigneeUser} from './RequestConstants';

function isUserAssignee(assignee: RequestAssignee): assignee is RequestAssigneeUser {
  return assignee.user != null;
}

export function unpackRequestAssignees(assignees: Array<RequestAssignee>): Array<User | Team> {
  return assignees.map((assignee) => (isUserAssignee(assignee) ? assignee.user : assignee.team));
}
